import React from 'react';
import { Tooltip } from '@mui/material';
import { ButtonCtn, DialogButton, StyledSaveIcon } from './styles';

const AddressbookDialogButton = props => {
  const { index, handleOpenAddressbookDialog, disabled, isDeliveryFormPristine } = props;

  return (
    <ButtonCtn>
      <DialogButton
        onClick={() => handleOpenAddressbookDialog(index, isDeliveryFormPristine)}
        disabled={disabled}
      >
        <Tooltip title="Save to addressbook">
          <StyledSaveIcon isDisabled={disabled} />
        </Tooltip>
      </DialogButton>
    </ButtonCtn>
  );
};

export default AddressbookDialogButton;
